module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skin-green sidebar-mini"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('va-navibar-orange'), _vm._v(" "), _c('va-slider-orange'), _vm._v(" "), _c('va-content-wrap', {
    staticStyle: {
      "background-color": "#F6F6F6"
    }
  }), _vm._v(" "), _c('Modal')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64f4eca3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MasterOrange.vue
// module id = 526
// module chunks = 1